import { memo, useCallback, useEffect } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { TranslationSearchFilterProps } from "./types";

import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { useTranslate } from "helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLanguages,
  getLanguages,
} from "services/api/languages/redux";
import { initialTranslationSearchForm } from "services/api/translations/consts";

const TranslationSearchFilters: React.FC<TranslationSearchFilterProps> = (
  props
) => {
  const { formValues, onSearchChange } = props;
  const dispatch = useDispatch();
  const { t } = useTranslate();

  const languages = useSelector(getLanguages);

  useEffect(() => {
    dispatch(fetchLanguages() as any);
  }, [dispatch]);

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialTranslationSearchForm);
  }, [onSearchChange]);

  const languageItems: DropdownOption[] = languages.items?.map((i) => {
    return {
      value: i.id.toString(),
      text: i.name,
    };
  });

  const handleDropdownChange = useCallback(
    (e: any, name: string, item: DropdownOption) => {
      onSearchChange({ ...formValues, languageId: item.value });
    },
    [formValues, onSearchChange]
  );
  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>
            <div>
              <Dropdown
                name="value"
                placeholder={t("admin.languages.choose")}
                options={languageItems}
                onChange={handleDropdownChange}
                value={formValues.languageId}
                width="small"
                cssClassName="bg-white"
              ></Dropdown>
            </div>
            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(TranslationSearchFilters);
